import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, FileText, Building2, Scale } from 'lucide-react';
import { servicios } from '../mock';

const iconMap = {
  Briefcase: Briefcase,
  FileText: FileText,
  Building2: Building2,
  Scale: Scale
};

const ServiciosDestacados = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Conoce Nuestros Servicios</h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            En la Secretaría de Economía y Trabajo de Yucatán trabajamos para impulsar el desarrollo laboral del estado. 
            Explora nuestros servicios:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {servicios.map((servicio) => {
            const IconComponent = iconMap[servicio.icono];
            return (
              <Link
                key={servicio.id}
                to={servicio.link}
                className="group bg-white rounded-xl p-6 border border-gray-200 hover:shadow-xl hover:border-[#8B1538] transition-all duration-300 text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#8B1538]/10 to-[#8B1538]/20 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                  <IconComponent className="h-8 w-8 text-[#8B1538]" />
                </div>
                
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-[#8B1538] transition-colors">
                  {servicio.nombre}
                </h3>
                
                <p className="text-sm text-gray-600">
                  {servicio.descripcion}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiciosDestacados;